import styled from 'styled-components';
import Dialog from '../base-dialog/base-dialog.component';
import { THEME } from '../../../themes';

export const StyledDialog = styled(Dialog)`
  padding: ${THEME.SPACING.MEDIUM};
  gap: ${THEME.SPACING.BASE};
`;
